import Card from '../../card/Card'
import CardBody from '../../card/CardBody'
import GridContainer from '../../grid/GridContainer'
import GridItem from '../../grid/GridItem'
import Button from '../../button/RegularButton'
import * as React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../../assets/jss/dorm-app/components/cardStyle'
import CustomInput from '../../input/CustomInput'

const useStyles = makeStyles(styles)

export function DepartmentEditDeparture(props) {
  const classes = useStyles()

  const { departure, index, newAmounts, setNewAmounts, handleUpdateAmount } = props

  return (
    <Card nested profile>
      <CardBody plain>
        <h4 className={classes.cardTitle}>{departure.tenantFullName}</h4>
        <h5>
          <small> Aktueller Betrag: {departure.signature.amount} Euro</small>
        </h5>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <CustomInput
              labelText="Neuer Betrag"
              id={departure.departureId}
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: newAmounts[index],
                type: 'text',
                onChange: (e) => {
                  let tmp = newAmounts.slice()
                  tmp[index] = e.currentTarget.value
                  setNewAmounts(tmp)
                },
              }}
            />
          </GridItem>

          <GridItem xs={12} sm={12} md={12}>
            <Button
              color="primary"
              onClick={() => {
                handleUpdateAmount(departure.departureId, newAmounts[index])
              }}>
              Betrag aktualisieren
            </Button>
          </GridItem>
        </GridContainer>
      </CardBody>
    </Card>
  )
}
